// components/ShareButton.jsx
import React, { useState } from 'react';
import "./style/ShareButton.css";

const ShareButton = ({ shopId, shopName }) => {
    const [showShareOptions, setShowShareOptions] = useState(false);
    const [copied, setCopied] = useState(false);

    // Generate the shareable link
    const getShareLink = () => {
        const baseUrl = window.location.origin;
        return `${baseUrl}/${shopId}`;
    };

    const shareLink = getShareLink();

    // Share via WhatsApp
    const shareWhatsApp = () => {
        const text = `Check out ${shopName || 'this shop'} on MK Shop!`;
        const url = `https://wa.me/?text=${encodeURIComponent(text + ' ' + shareLink)}`;
        window.open(url, '_blank');
        setShowShareOptions(false);
    };

    // Share via Facebook
    const shareFacebook = () => {
        const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareLink)}`;
        window.open(url, '_blank');
        setShowShareOptions(false);
    };

    // Share via Twitter/X
    const shareTwitter = () => {
        const text = `Check out ${shopName || 'this shop'} on MK Shop!`;
        const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(shareLink)}`;
        window.open(url, '_blank');
        setShowShareOptions(false);
    };

    // Share via Email
    const shareEmail = () => {
        const subject = `Check out ${shopName || 'this shop'} on MK Shop`;
        const body = `I found this amazing shop on MK Shop. Check it out: ${shareLink}`;
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        setShowShareOptions(false);
    };

    // Copy link to clipboard
    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(shareLink);
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        } catch (err) {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = shareLink;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        }
        setShowShareOptions(false);
    };

    // Share via native share API (mobile)
    const nativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: shopName || 'MK Shop',
                    text: `Check out ${shopName || 'this shop'} on MK Shop!`,
                    url: shareLink,
                });
            } catch (error) {
                console.log('Error sharing:', error);
            }
        } else {
            setShowShareOptions(!showShareOptions);
        }
    };

    return (
        <div className="share-container">
            {/* Main Share Button */}
            <button 
                className="share-btn"
                onClick={nativeShare}
                aria-label="Share shop"
            >
                <span className="share-icon">📤</span>
                <span className="share-text">Share</span>
            </button>

            {/* Desktop Share Options */}
            {showShareOptions && (
                <>
                    {/* Backdrop */}
                    <div className="share-backdrop" onClick={() => setShowShareOptions(false)}></div>
                    
                    <div className="share-dropdown">
                        <div className="share-dropdown-header">
                            <h4>Share this shop</h4>
                            <button 
                                className="share-close"
                                onClick={() => setShowShareOptions(false)}
                            >
                                ✕
                            </button>
                        </div>
                        
                        <div className="share-options">
                            <button onClick={shareWhatsApp} className="share-option whatsapp">
                                <span className="share-icon">💬</span>
                                <span>WhatsApp</span>
                            </button>
                            
                            <button onClick={shareFacebook} className="share-option facebook">
                                <span className="share-icon">📘</span>
                                <span>Facebook</span>
                            </button>
                            
                            <button onClick={shareTwitter} className="share-option twitter">
                                <span className="share-icon">🐦</span>
                                <span>Twitter</span>
                            </button>
                            
                            <button onClick={shareEmail} className="share-option email">
                                <span className="share-icon">📧</span>
                                <span>Email</span>
                            </button>
                        </div>

                        <div className="share-link-container">
                            <input 
                                type="text" 
                                value={shareLink} 
                                readOnly 
                                className="share-link-input"
                            />
                            <button 
                                onClick={copyToClipboard} 
                                className={`copy-btn ${copied ? 'copied' : ''}`}
                            >
                                {copied ? '✅ Copied!' : '📋 Copy'}
                            </button>
                        </div>
                    </div>
                </>
            )}

            {/* Success Toast */}
            {copied && (
                <div className="copy-toast">
                    Link copied to clipboard! 📋
                </div>
            )}
        </div>
    );
};

export default ShareButton;